import { gql } from "apollo-boost";

const searchGooglePlaces = gql`
  query searchGooglePlaces($keyword: String) {
    searchGooglePlaces(keyword: $keyword) {
      placeId
      addr
    }
  }
`;

export const utilsGql = {
  searchGooglePlaces,
};
